var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27539 2.15446C7.74161 1.97318 8.25938 1.97316 8.72559 2.15446L12.3789 3.57536C12.8981 3.77732 13.2402 4.27805 13.2402 4.83512V6.20426C13.2402 9.19976 11.6489 11.9702 9.06152 13.4797C8.40591 13.8621 7.59506 13.8621 6.93945 13.4797C4.35194 11.9703 2.76074 9.19985 2.76074 6.20426V4.83512C2.76076 4.278 3.10282 3.77729 3.62207 3.57536L7.27539 2.15446ZM8 10.0002C7.66895 10.0004 7.40061 10.2687 7.40039 10.5998C7.40039 10.931 7.66881 11.2001 8 11.2004C8.33137 11.2004 8.60059 10.9311 8.60059 10.5998C8.60036 10.2686 8.33123 10.0002 8 10.0002ZM8 5.00016C7.46904 5.00016 7.05817 5.46549 7.12402 5.99235L7.4375 8.50407C7.47293 8.7875 7.71436 9.00016 8 9.00016C8.28563 9.00016 8.52609 8.78748 8.56152 8.50407L8.87598 5.99235C8.94181 5.46552 8.53091 5.0002 8 5.00016Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceExpired);
export default __webpack_public_path__ + "static/media/Insurance_expired.9794050db97b2379e0f2e65f6cea7fab.svg";
export { ForwardRef as ReactComponent };